import { render } from "./AgendaView.vue?vue&type=template&id=afe59cb0&scoped=true"
import script from "./AgendaView.vue?vue&type=script&lang=js"
export * from "./AgendaView.vue?vue&type=script&lang=js"

import "./AgendaView.vue?vue&type=style&index=0&id=afe59cb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe59cb0"]])

export default __exports__